import { Svg, Path } from '../_Svg';
import type { IconComponent } from '..';
import useIconProps from '../useIconProps';
import { assignWithoutSideEffects } from '~utils/assignWithoutSideEffects';

const _MagicCheckoutIcon: IconComponent = ({ size, color, ...styledProps }) => {
  const { height, width, iconColor } = useIconProps({ size, color });

  return (
    <Svg {...styledProps} width={width} height={height} viewBox="0 0 24 24" fill="none">
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2C11.2044 2 10.4413 2.31607 9.87868 2.87868C9.31607 3.44129 9 4.20435 9 5H15C15 4.20435 14.6839 3.44129 14.1213 2.87868C13.5587 2.31607 12.7956 2 12 2ZM17 5H21C21.5523 5 22 5.44772 22 6V20C22 20.7957 21.6839 21.5587 21.1213 22.1213C20.5587 22.6839 19.7957 23 19 23H5C4.20435 23 3.44129 22.6839 2.87868 22.1213C2.31607 21.5587 2 20.7957 2 20V6C2 5.44772 2.44772 5 3 5H7C7 3.67392 7.52678 2.40215 8.46447 1.46447C9.40215 0.526784 10.6739 0 12 0C13.3261 0 14.5979 0.526784 15.5355 1.46447C16.4732 2.40215 17 3.67392 17 5ZM4 7V20C4 20.2652 4.10536 20.5196 4.29289 20.7071C4.48043 20.8946 4.73478 21 5 21H10.6605L10.8827 19H6C5.6223 19 5.27682 18.7872 5.10691 18.4499C4.93699 18.1126 4.97163 17.7083 5.19644 17.4048L11.8631 8.40477C12.1321 8.04157 12.6114 7.90399 13.0321 8.06916C13.4528 8.23434 13.7105 8.6612 13.6606 9.11043L13.1173 14H18C18.3777 14 18.7232 14.2128 18.8931 14.5501C19.063 14.8874 19.0284 15.2917 18.8036 15.5952L14.8 21H19C19.2652 21 19.5196 20.8946 19.7071 20.7071C19.8946 20.5196 20 20.2652 20 20V7H4ZM12.7367 20.4255L16.0148 16H12C11.7156 16 11.4446 15.8789 11.2549 15.6669C11.0652 15.455 10.9747 15.1723 11.0061 14.8896L11.2633 12.5745L7.98521 17H12C12.2844 17 12.5554 17.1211 12.7451 17.3331C12.9348 17.545 13.0253 17.8277 12.9939 18.1104L12.7367 20.4255Z"
        fill={iconColor}
      />
    </Svg>
  );
};

const MagicCheckoutIcon = assignWithoutSideEffects(_MagicCheckoutIcon, {
  componentId: 'MagicCheckoutIcon',
});

export default MagicCheckoutIcon;
